import { FormattedMessage } from 'dibs-react-intl';

export const trendingNowTitle = (
    <FormattedMessage id="HpSharedCarouselTabs.title" defaultMessage="Trending Now" />
);

export const trendingNowMostSavedItems = (
    <FormattedMessage
        id="HpSharedCarouselTabs.collectionTitle.mostSavedItems"
        defaultMessage="Most-Saved Items"
    />
);

export const trendingNowExcellentValues = (
    <FormattedMessage
        id="HpSharedCarouselTabs.collectionTitle.excellentValues"
        defaultMessage="Excellent Values"
    />
);

export const trendingNowBestsellingDesigns = (
    <FormattedMessage
        id="HpSharedCarouselTabs.collectionTitle.bestsellingDesigns"
        defaultMessage="Best-Selling Designs"
    />
);
